// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/hostel.jpg";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// Firebase
import { ResetPassword } from "framework/authentication/authuser";
import { useState } from "react";
import BasicLayout from "../components/BasicLayout";

function Cover() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({});

  const toggleSnackbar = () => {
    setShowSnackbar(!showSnackbar);
  };

  function onUserEnterEmail(e) {
    setEmail(e.target.value);
  }

  async function onUserClickReset() {
    setIsLoading(true);
    try {
      await ResetPassword(email);
      console.log("reset mail sent");
      setIsLoading(false);

      setSnackbarProps({
        color: "success",
        icon: "check_circle",
        title: "Reset mail sent",
        content: "A password reset email has been sent to your email address.",
      });

      setShowSnackbar(true);
    } catch (error) {
      setIsLoading(false);

      let title = "";
      let content = "";
      if (error.code === "auth/user-not-found") {
        title = "Account not found";
        content = "There are no accounts associated with the given email address.";
      } else if (error.code === "auth/invalid-email") {
        title = "Invalid email address";
        content = "Invalid email address. Please check for mistakes and try again.";
      } else {
        console.log("firebase-auth-error", error, "firebase-auth-error-code", error.code);
        title = "An unknown error occurred";
        content = (
          <>
            Please try again later or contact support.
            <br />
            Error code: {error.code}.
          </>
        );
      }
      setSnackbarProps({
        color: "error",
        icon: "error",
        title: title,
        content: content,
      });

      setShowSnackbar(true);
    }
  }

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Reset Password
          </MDTypography>
          {/* <MDTypography display="block" variant="button" color="white" my={1}>
            You will receive an e-mail in maximum 60 seconds
          </MDTypography> */}
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={4}>
              <MDInput
                type="email"
                label="Email"
                variant="standard"
                fullWidth
                onChange={onUserEnterEmail}
              />
            </MDBox>

            <MDBox mt={6} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={onUserClickReset}
                disabled={isLoading}
              >
                reset
              </MDButton>
              <MDBox mt={3} mb={1} textAlign="center">
                <MDTypography variant="button" color="text">
                  {" "}
                  <MDTypography
                    component={Link}
                    to="authentication/sign-in"
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                  >
                    Back to sign-in
                  </MDTypography>
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>{" "}
      <MDSnackbar
        color={snackbarProps.color}
        icon={snackbarProps.icon || ""}
        title={snackbarProps.title || ""}
        content={snackbarProps.content || ""}
        dateTime=""
        open={showSnackbar}
        close={toggleSnackbar}
      />
    </BasicLayout>
  );
}

export default Cover;
